<template>
  <div class="home-title-box flex align-center">
    <el-image class="m-r-20" style="width: 54px; height: 54px" :src="iconList[icon]" fit="fill"></el-image>
    <div>
      <div class="fwb fs28 m-b-4 flex">
        {{ title }}
        <span class="iconfont icon-xing m-l-8"></span>
      </div>
      <div class="fs14 sub-title just-font" :class="$themeStyle($store.state.theme.theme)">
        {{ subTitle }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    icon: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      postIs: this.$store.state.user.logo,
      iconList: [
        require("../../../assets/homeIcon2.png"),
        require("../../../assets/homeIcon1.png"),
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.home-title-box {
  margin: 26px 0;

  .light {
    color: $greyFontColor;
  }
}
</style>
